import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Badge from '@mui/material/Badge';

import { AppState } from 'store/configureStore';

interface DashboardLinkProps {
    handleDrawerClose: () => void;
    route: {
        icon: any;
        name: string;
        route: string;
        permission: string;
        countKey?: string;
    };
    badgeCount?: number;
}

const DashboardLink: React.FC<DashboardLinkProps> = ({ route: val, handleDrawerClose, badgeCount }) => {
    const permissions = useSelector((state: AppState) => state.auth.permissions);

    if (val.permission && !permissions.includes(val.permission)) return null;

    const count = val.countKey != null ? badgeCount : undefined;
    const showBadge = count !== undefined && count > 0;

    return (
        <NavLink onClick={handleDrawerClose} to={val.route} end>
            <div className="router-link">
                {showBadge ? (
                    <Badge badgeContent={count} color="primary">
                        <val.icon />
                    </Badge>
                ) : (
                    <val.icon />
                )}
                <p>{val.name}</p>
            </div>
        </NavLink>
    );
};

export default DashboardLink;
